import React from 'react';

interface HospitalIconProps {
  className?: string;
  size?: number;
}

export const HospitalIcon: React.FC<HospitalIconProps> = ({ 
  className = '', 
  size = 150 
}) => {
  return (
    <svg 
      id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      version="1.1" 
      viewBox="0 0 150 150"
      width={size}
      height={size}
      className={className}
    >
      <defs>
        <style>
          {`.st0 {
            fill: none;
            stroke: #e3e3e3;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 9px;
          }`}
        </style>
      </defs>
      <path className="st0" d="M87.2,35.09l7.89-.04c6.59-.04,12.16,4.85,13,11.38l1.88,29.98"/>
      <ellipse className="st0" cx="73.56" cy="47.5" rx="14.47" ry="17.67"/>
      <path className="st0" d="M37.22,74.94l1.79-28.28c.83-6.48,6.32-11.34,12.85-11.38l11.31-.06"/>
      <path className="st0" d="M83.55,63.6l15,4.41c6.51,1.91,11.63,6.96,13.63,13.45l2.71,8.77"/>
      <polyline className="st0" points="11.82 120.17 19.02 90.22 128.06 90.22 135.26 120.17"/>
      <line className="st0" x1="15.74" y1="103.85" x2="114.46" y2="103.85"/>
      <path className="st0" d="M30.9,90.22l3.99-8.77c2-6.49,7.12-11.54,13.64-13.45l17.79-5.22"/>
    </svg>
  );
};
